/**
 * Catalogue Kōken des produits de gamification
 * Templates disponibles pour activation par les entreprises
 */

import { GamificationProductTemplate } from '@/types/gamificationProducts';

export type { GamificationProductTemplate } from '@/types/gamificationProducts';

export const GAMIFICATION_PRODUCTS_CATALOG: GamificationProductTemplate[] = [
  // === STREAK PROTECTION (GELS PAR QUANTITÉ) ===
  {
    id: 'freeze-single',
    type: 'streak_freeze',
    name: 'Gel de Série ×1',
    description: 'Un gel pour protéger votre série pendant 1 jour',
    icon: '🛡️',
    category: 'protection',
    effectConfig: {
      protectionDaysPerUse: 1,
      quantity: 1
    },
    defaultPrice: 15,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'common',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'freeze-duo',
    type: 'streak_freeze',
    name: 'Gel de Série ×2 (Duo)',
    description: 'Pack de 2 gels - économisez 10% ! Chaque gel protège 1 jour',
    icon: '🛡️',
    category: 'protection',
    effectConfig: {
      protectionDaysPerUse: 1,
      quantity: 2
    },
    defaultPrice: 27,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'rare',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'freeze-trio',
    type: 'streak_freeze',
    name: 'Gel de Série ×3 (Trio)',
    description: 'Pack de 3 gels - économisez 15% ! Chaque gel protège 1 jour',
    icon: '🛡️',
    category: 'protection',
    effectConfig: {
      protectionDaysPerUse: 1,
      quantity: 3
    },
    defaultPrice: 38,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'epic',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  // === LEGACY FREEZE IDS (pour rétrocompatibilité) ===
  {
    id: 'freeze-basic',
    type: 'streak_freeze',
    name: 'Gel de Série ×1',
    description: 'Un gel pour protéger votre série pendant 1 jour',
    icon: '🛡️',
    category: 'protection',
    effectConfig: {
      protectionDaysPerUse: 1,
      quantity: 1
    },
    defaultPrice: 15,
    defaultStock: null,
    isActive: false, // Désactivé pour nouvelles ventes
    releaseDate: '2025-01-01',
    rarity: 'common'
  },
  {
    id: 'freeze-premium',
    type: 'streak_freeze',
    name: 'Gel de Série ×2',
    description: 'Pack de 2 gels',
    icon: '🛡️',
    category: 'protection',
    effectConfig: {
      protectionDaysPerUse: 1,
      quantity: 2
    },
    defaultPrice: 27,
    defaultStock: null,
    isActive: false,
    releaseDate: '2025-01-01',
    rarity: 'rare'
  },
  {
    id: 'freeze-ultimate',
    type: 'streak_freeze',
    name: 'Gel de Série ×3',
    description: 'Pack de 3 gels',
    icon: '🛡️',
    category: 'protection',
    effectConfig: {
      protectionDaysPerUse: 1,
      quantity: 3
    },
    defaultPrice: 38,
    defaultStock: null,
    isActive: false,
    releaseDate: '2025-01-01',
    rarity: 'epic'
  },

  // === BOOST MULTIPLIERS ===
  {
    id: 'boost-sprint',
    type: 'boost_multiplier',
    name: 'Boost Sprint',
    description: 'Doublez vos points et XP pendant 24h',
    icon: '🚀',
    category: 'boost',
    effectConfig: {
      multiplier: 2,
      durationHours: 24
    },
    defaultPrice: 30,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'common',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'boost-marathon',
    type: 'boost_multiplier',
    name: 'Boost Marathon',
    description: 'Doublez vos points et XP pendant 48h',
    icon: '🚀',
    category: 'boost',
    effectConfig: {
      multiplier: 2,
      durationHours: 48
    },
    defaultPrice: 50,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'rare',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'mega-boost',
    type: 'boost_multiplier',
    name: 'Méga Boost',
    description: 'Doublez vos points et XP pendant 12h - boost intense et rapide !',
    icon: '⚡',
    category: 'boost',
    effectConfig: {
      multiplier: 2,
      durationHours: 12
    },
    defaultPrice: 40,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'epic',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'boost-power-hour',
    type: 'boost_multiplier',
    name: 'Power Hour',
    description: 'Triplez vos gains pendant 1 heure intense - le boost ultime !',
    icon: '⚡',
    category: 'boost',
    effectConfig: {
      multiplier: 3,
      durationHours: 1
    },
    defaultPrice: 25,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'epic',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },

  // === VALIDATION BOOST - LIMITES AUGMENTÉES ===
  {
    id: 'validation-boost-manual-small',
    type: 'validation_boost',
    name: 'Manuel+ (×2)',
    description: '+2 validations manuelles pendant 24h',
    icon: '✋',
    category: 'boost',
    effectConfig: {
      validationBonusLimit: 2,
      validationType: 'manual',
      durationHours: 24
    },
    defaultPrice: 10,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'common',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'validation-boost-manual-large',
    type: 'validation_boost',
    name: 'Manuel++ (×5)',
    description: '+5 validations manuelles pendant 24h',
    icon: '✋',
    category: 'boost',
    effectConfig: {
      validationBonusLimit: 5,
      validationType: 'manual',
      durationHours: 24
    },
    defaultPrice: 20,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'rare',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'validation-boost-photo',
    type: 'validation_boost',
    name: 'Photo IA+ (×2)',
    description: '+2 validations Photo IA pendant 24h',
    icon: '📸',
    category: 'boost',
    effectConfig: {
      validationBonusLimit: 2,
      validationType: 'photoAI',
      durationHours: 24
    },
    defaultPrice: 15,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'rare',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'validation-boost-gps',
    type: 'validation_boost',
    name: 'GPS+ (×2)',
    description: '+2 validations GPS pendant 24h',
    icon: '📍',
    category: 'boost',
    effectConfig: {
      validationBonusLimit: 2,
      validationType: 'location',
      durationHours: 24
    },
    defaultPrice: 15,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'rare',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'validation-boost-p2p',
    type: 'validation_boost',
    name: 'P2P+ (×5)',
    description: '+5 validations Peer-to-Peer pendant 24h',
    icon: '🤝',
    category: 'boost',
    effectConfig: {
      validationBonusLimit: 5,
      validationType: 'peerToPeer',
      durationHours: 24
    },
    defaultPrice: 18,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'rare',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'validation-boost-all',
    type: 'validation_boost',
    name: 'Super Validateur',
    description: '+3 sur TOUTES les méthodes de validation pendant 24h',
    icon: '⚡',
    category: 'boost',
    effectConfig: {
      validationBonusLimit: 3,
      validationType: 'all',
      durationHours: 24
    },
    defaultPrice: 40,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'epic',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },

  // === DASHBOARD THEMES PREMIUM ===
  // Le theme Koken est le seul moyen, pour un salarie dont l'organisation impose
  // une marque blanche, de reprendre l'apparence Koken. Acquis definitivement :
  // pas de duree, pas de consommation (cf. useOrganizationForcedTheme qui cede
  // la priorite des que l'utilisateur a choisi ce theme).
  {
    id: 'theme-koken',
    type: 'dashboard_theme',
    name: '✨ Thème Kōken',
    description: 'Reprenez la main sur l\'apparence : remplacez le thème imposé par votre organisation par l\'identité Kōken. Acquis définitivement.',
    icon: '✨',
    category: 'customization',
    effectConfig: {
      themeId: 'default',
    },
    defaultPrice: 800,
    defaultStock: null,
    isActive: true,
    releaseDate: '2026-09-13',
    rarity: 'rare',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'theme-champagne-gold',
    type: 'dashboard_theme',
    name: '🥂 Champagne Gold',
    description: 'Élégance française - Or champagne, rose gold et platine. Le luxe à l\'état pur.',
    icon: '🥂',
    category: 'customization',
    effectConfig: {
      themeId: 'champagne-gold',
      themeColors: {
        primary: 'hsl(43, 96%, 68%)',        // Or Champagne
        secondary: 'hsl(20, 85%, 75%)',      // Or Rose
        accent: 'hsl(43, 100%, 72%)',        // Or éclatant
        platinum: 'hsl(240, 10%, 85%)',      // Platine
        background: 'hsl(45, 20%, 97%)',     // Blanc cassé
        backgroundDark: 'hsl(220, 30%, 8%)', // Noir profond
      }
    },
    defaultPrice: 250,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'legendary',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'theme-royal-purple',
    type: 'dashboard_theme',
    name: '👑 Royal Purple & Gold',
    description: 'Majesté impériale - Violet royal + Or 24 carats. Pour les conquérants.',
    icon: '👑',
    category: 'customization',
    effectConfig: {
      themeId: 'royal-purple',
      themeColors: {
        primary: 'hsl(275, 90%, 55%)',       // Violet Royal
        secondary: 'hsl(45, 100%, 51%)',     // Or 24 carats
        accent: 'hsl(285, 70%, 35%)',        // Pourpre Impérial
        background: 'hsl(45, 30%, 98%)',     // Ivoire
        backgroundDark: 'hsl(260, 40%, 10%)', // Noir impérial
      }
    },
    defaultPrice: 300,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-15',
    rarity: 'legendary',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'theme-midnight-platinum',
    type: 'dashboard_theme',
    name: '🌙 Midnight Platinum',
    description: 'Technologie futuriste - Argent platine + Bleu nuit + Cyan. L\'avenir du luxe.',
    icon: '🌙',
    category: 'customization',
    effectConfig: {
      themeId: 'midnight-platinum',
      themeColors: {
        primary: 'hsl(210, 25%, 75%)',       // Argent Platine
        secondary: 'hsl(220, 50%, 25%)',     // Bleu Nuit
        accent: 'hsl(190, 100%, 50%)',       // Cyan Électrique
        background: 'hsl(210, 15%, 95%)',    // Gris Glacé
        backgroundDark: 'hsl(210, 30%, 8%)', // Noir Carbone
      }
    },
    defaultPrice: 280,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-02-01',
    rarity: 'legendary',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },

  // === PRODUITS SPÉCIAUX KŌKEN ===
  {
    id: 'challenge-reveal',
    type: 'special',
    name: 'Challenge Reveal 🔮',
    description: 'Révèle un challenge bonus caché de la semaine ! Accès exclusif à un défi secret avec récompenses spéciales.',
    icon: '🔮',
    category: 'special',
    effectConfig: {
      specialEffectId: 'challenge_reveal',
      accessDuration: 7 // 7 jours pour compléter le challenge révélé
    },
    defaultPrice: 30,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'epic',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'team-aura',
    type: 'special',
    name: 'Team Aura ✨',
    description: '+20% XP pour toute votre équipe pendant 24h ! L\'effet se propage à tous les membres actifs.',
    icon: '✨',
    category: 'special',
    effectConfig: {
      specialEffectId: 'team_aura',
      teamBonus: 20,
      durationHours: 24
    },
    defaultPrice: 50,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'legendary',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'leaderboard-time-machine',
    type: 'special',
    name: 'Time Machine 🕰️',
    description: 'Débloquez l\'accès complet à l\'historique des classements sur 1 an. Analysez vos performances passées !',
    icon: '🕰️',
    category: 'special',
    effectConfig: {
      specialEffectId: 'leaderboard_history',
      accessDuration: 365 // 1 an d'accès
    },
    defaultPrice: 25,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'rare',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'streak-insurance',
    type: 'special',
    name: 'Streak Insurance 🛡️⚡',
    description: 'Assurance automatique ! Si votre série est sur le point de casser, un gel est consommé automatiquement.',
    icon: '🛡️',
    category: 'special',
    effectConfig: {
      specialEffectId: 'streak_insurance',
      autoProtect: true,
      protectionDaysPerUse: 1
    },
    defaultPrice: 40,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'epic',
    managerConfigurable: true,
    defaultSourceType: 'both'
  },
  {
    id: 'goal-accelerator',
    type: 'special',
    name: 'Goal Accelerator 🎯',
    description: 'Accorde un bonus de +25% XP sur vos complétions d\'objectifs pendant 48h. Atteignez vos buts plus vite !',
    icon: '🎯',
    category: 'special',
    effectConfig: {
      specialEffectId: 'goal_accelerator',
      xpBonusPercent: 25,
      durationHours: 48
    },
    defaultPrice: 35,
    defaultStock: null,
    isActive: true,
    releaseDate: '2025-01-01',
    rarity: 'epic',
    managerConfigurable: true,
    defaultSourceType: 'both'
  }
];

/**
 * Récupère un template par son ID
 */
export const getProductTemplate = (templateId: string): GamificationProductTemplate | undefined => {
  return GAMIFICATION_PRODUCTS_CATALOG.find(p => p.id === templateId);
};

/**
 * Récupère tous les templates actifs d'une catégorie
 */
export const getProductsByCategory = (category: GamificationProductTemplate['category']): GamificationProductTemplate[] => {
  return GAMIFICATION_PRODUCTS_CATALOG.filter(p => p.category === category && p.isActive);
};

/**
 * Récupère tous les templates actifs d'un type
 */
export const getProductsByType = (type: GamificationProductTemplate['type']): GamificationProductTemplate[] => {
  return GAMIFICATION_PRODUCTS_CATALOG.filter(p => p.type === type && p.isActive);
};
